import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Fieldset extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form-group']: true
        });

        return (
            <fieldset className={classNames} {...props}>
                {children}
            </fieldset>
        );
    }
}

Fieldset.defaultProps = {};

export default Fieldset;
